import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'
import { Body } from './Body'
import { Header } from './Header'
import { Footer } from './Footer'

interface Props {
  previewUrl: string
}

export function Content(props: Props) {
  const { previewUrl } = props
  const { ready } = useConfigureController(previewUrl)

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />}>
      <Body />
    </ModalContent>
  )
}
